import React, { useContext } from "react";

import "../../../ui/widgets/table-light/styles.scss";
import GridContainer from "../../../ui/layout/page/container/GridContainer";
import Notes from "./notes";
import { ProductContext } from "../../../context/product-context/productContext";
import Details from "./details";
import DetailsSwisscard from "./detailsSwisscard";

export default function InsurancePlusInfo(): React.JSX.Element {
  const { selectedProduct } = useContext(ProductContext);
  const showGeneralDetails =
    selectedProduct?.hasFeature("INSURANCE_PLUS_OPTIONAL") ||
    selectedProduct?.hasFeature("INSURANCE_PLUS_INCLUDED");

  const showSwisscardDetails =
    selectedProduct?.hasFeature("INSURANCE_PLUS_OPTIONAL_SWISSCARD") ||
    selectedProduct?.hasFeature("INSURANCE_PLUS_INCLUDED_SWISSCARD");

  return (
    <GridContainer spacing={0}>
      {showGeneralDetails && <Details />}
      {showSwisscardDetails && <DetailsSwisscard />}
      <Notes showSwisscardDetails={showSwisscardDetails} />
    </GridContainer>
  );
}
